import { Map } from 'immutable'
import {
  SET_CONTENT_IMPRESSION_PROCESSING,
  SET_CONTENT_IMPRESSION_ERROR,
  SET_CONTENT_IMPRESSION_DATA,
} from './actions'

export const initialState = Map()

export default (state = initialState, action) => {
  const { payload, type } = action
  switch (type) {
    case SET_CONTENT_IMPRESSION_PROCESSING:
      return state.set('processing', payload.processing)
    case SET_CONTENT_IMPRESSION_DATA:
      return state.set('data', payload.data).set('processing', payload.processing).delete('error')
    case SET_CONTENT_IMPRESSION_ERROR:
      return state.set('error', payload.error).set('processing', payload.processing)
    default:
      return state
  }
}
